import {connect} from 'react-redux';
import ContentPartnerContainer from '../ContentPartnerContainer';
import {
    setContentPartnerInitialValuesAction,
    editContentPartnerAction,
    resetContentPartnerInitialValuesAction,
} from './Redux/EditingContentPartnerAction';
import {ContentPartnerState} from '../ContentPartnersTypes';

export interface ContentPartnersManagerState {
    contentPartnersManager: ContentPartnerState;
}

export const mapState = ({contentPartnersManager}: ContentPartnersManagerState) => ({
    initialValues: contentPartnersManager,
});

const mapDispatch = {
    setInitialValuesForEditingItem: setContentPartnerInitialValuesAction,
    resetInitialValuesForEditingItem: resetContentPartnerInitialValuesAction,
    saveContentPartner: editContentPartnerAction,
};

export default connect(mapState, mapDispatch)(ContentPartnerContainer);
